module.exports = __webpack_public_path__ + "static/media/bet-white-5.e84d748a.png";